import { api } from './client';

export const NotificationsAPI = {
  mine: () => api.get('/notifications'),
  markRead: (ids) => api.post('/notifications/read', { ids }),
  broadcast: (payload) => api.post('/admin/notifications/broadcast', payload),
};
